/**
 * @flow
 */
import {Action, Dispatch} from 'redux'

export interface SharedDataState {
  companies: Object[];
  branches: Object[];
  groups: Object[];
  deviceTypes: Object[];
}

export interface SharedDataAction extends Action {
  companies?: Object[];
  branches?: Object[];
  groups?: Object[];
  deviceTypes?: Object[];
}

export function sharedDataReducer(state: SharedDataState = {}, action: SharedDataAction): SharedDataState {
  const {type, ...rest} = action;
  if(type === 'SHARED_DATA_UPDATE') {
    return {...state, ...rest};
  } else {
    return state;
  }
}

export function updateSharedCompanyList(dispatch: Dispatch, companies: Array) {
  dispatch({type: 'SHARED_DATA_UPDATE', companies})
}

export function updateSharedBranchList(dispatch: Dispatch, branches: Array) {
  dispatch({type: 'SHARED_DATA_UPDATE', branches})
}

export function updateSharedGroupList(dispatch: Dispatch, groups: Array) {
  dispatch({type: 'SHARED_DATA_UPDATE', groups})
}

export function updateSharedDeviceTypeList(dispatch: Dispatch, deviceTypes: Array) {
  dispatch({type: 'SHARED_DATA_UPDATE', deviceTypes})
}

export function clearSharedData(dispatch: Dispatch) {
  dispatch({type: 'SHARED_DATA_UPDATE', companies: null, branches: null, groups: null, deviceTypes: null})
}
